/* global femcare */

femcare.tracking.product = {
    $productInfo: $('.product-main__info').not('.modal--quick-buy .product-main__info'),

    init () {
        const isEcommerce = this.$productInfo.parents('.product-main--shop').length;

        if (this.$productInfo.length) {

            this.powerReviewsAnalytics();
            this.bazaarVoiceAnalytics();
            this.initBuyNowRetailerAnalytics();
            this.viewProductAnalytics(this.$productInfo, isEcommerce);
        }
    },

    /**
     * Initializes retailer tracking for CMS-configured Buy now links.
     */
    initBuyNowRetailerAnalytics () {
        $('.product-main__buy-now[data-ga-event-id]').on('click', (event) => {
            const $button = $(event.currentTarget);
            const eventId = $button.data('ga-event-id');

            if (eventId) {
                femcare.tracking.analytics.pushConfiguredEvent(
                    eventId.toString(),
                    'ga4_buy_now_go_to_retailer',
                    false
                );
            }
        });
    },

    // GA4 Analytics
    powerReviewsAnalytics () {
        const isPowerReviewsLoaded = window.POWERREVIEWS;

        $('#pr-reviewdisplay').on('click', '.pr-snippet-write-review-link', (e) => {
            if (isPowerReviewsLoaded) {
                this.writeReview('Write a review cta click');
                e.stopPropagation();
            }
        });

        $('#pr-reviewdisplay').on('click', '#pr-war-form .pr-rating-stars label', (e) => {
            if (isPowerReviewsLoaded) {
                this.writeReview('Start to write a review');
                e.stopPropagation();
            }
        });

        $('#pr-reviewdisplay').on('click', '.pr-btn-review', (e) => {
            this.writeReview('Submit a review');
            e.stopPropagation();
        });
    },

    bazaarVoiceAnalytics () {
        const isBVLoaded = window.$BV;

        $('.show-reviews-container').on('click', '.bv-write-review, .bv-first-to-review', (e) => {
            if (isBVLoaded) {
                this.writeReview('Write a review cta click');
                e.stopPropagation();
            }
        })

        $('body').on('click', '.bv-form-actions-submit', (e) => {
            if (isBVLoaded) {
                this.writeReview('Submit a review');
                e.stopPropagation();
            }
        });
    },

    /**
     * Tracks clicks on the product cta-panel, but only for shoppable websites
     * @param {string} actionType Action type is type of ga4 review event
     */
    writeReview (actionType) {
        const reviewData = femcare.tracking.analytics.getConfiguredData('Name', 'ga4_review');
        if (!reviewData) return;

        femcare.tracking.analytics.pushEvent('ga4_review', {
            action_type: actionType,
            single_item_id: reviewData.single_item_id,
            single_item_name: reviewData.single_item_name
        });
    },

    // E-commerce events for products

    /**
     * Tracks clicks on the product cta-panel, but only for shoppable websites
     * @param {jQuery} $selectedProduct
     * @param {boolean} isEcommerce
     */
    selectProductAnalytics ($selectedProduct, isEcommerce) {
        const eventId = $selectedProduct[0].dataset.gaEventId;
        const eventType = $selectedProduct[0].dataset.gaEventType;

        if (isEcommerce) {
            const itemIndex = $selectedProduct.parent().index() + 1;
            const gaObjArray = femcare.shared.util.getEntryFromObject(window.gaDataLayer, 'Id', eventId);

            if (gaObjArray && gaObjArray.length > 0) {
                const gaObj = gaObjArray[0];
                if (gaObj && gaObj.Data) {
                    gaObj.Data.index = itemIndex;
                    femcare.tracking.analytics.pushConfiguredEvent(eventId, eventType, true);
                }
            }
        } else {
            femcare.tracking.analytics.pushConfiguredEvent(eventId, eventType, false);
        }
    },

    /**
     * Tracks load of PDP page
     * @param {jQuery} $product
     * @param {boolean} isEcommerce
    */
    viewProductAnalytics ($product, isEcommerce) {
        const eventId = $product[0].dataset.gaEventId;
        const eventType = $product[0].dataset.gaEventType;

        if (isEcommerce) {
            const productData = femcare.tracking.analytics.getConfiguredData('Id', eventId);
            if (productData) productData.index = 0;
        }

        femcare.tracking.analytics.pushConfiguredEvent(eventId, eventType, isEcommerce);
    },

    /**
    * Tracks change of product variant on PDP pages, but only for shoppable websites
    * @param {obj} productData
   */
    eccomViewProductVariantAnalytics (productData) {
        if (!productData) {
            return;
        }
        const adaptedProductData = {
            items: []
        };
        adaptedProductData.items[0] = productData
        const productVariantAnalytics = this.itemsData(adaptedProductData);

        femcare.tracking.analytics.pushEcommerce('view_item', { items: productVariantAnalytics });

    },

    /**
     * Triggers on adding product to cart
     * @param {obj} data
     * @param {number} count
     * @param {boolean} isQuickBuy
     */
    ecommAddProductToCart (data, count, isQuickBuy) {
        if (!data) return;

        femcare.tracking.analytics.pushEcommerce('add_to_cart', {
            items: [{
                item_id: data.productId,
                item_name: data.name,
                currency: data.priceInformation?.currency?.code,
                discount: data.priceInformation?.discount,
                index: 0,
                item_list_name: data.category,
                item_variant: data.productSkuName,
                price: data.priceInformation?.priceWithoutDiscountNoFormat,
                quantity: count
            }]
        }, { quick_buy: isQuickBuy });
    },

    /**
     * Triggers on adding product to cart
     * @param {obj} data
     * @param {number} count
     */
    ecommRemoveProductFromCart (data, count) {
        if (!data) return;

        femcare.tracking.analytics.pushEcommerce('remove_from_cart', {
            items: [{
                item_id: data.productId,
                item_name: data.name,
                currency: data.priceInformation?.currency?.code,
                item_variant: data.productSkuName,
                price: data.priceInformation?.priceWithoutDiscountNoFormat,
                quantity: Math.abs(count)
            }]
        });
    },

    /**
     * Triggers on view cart event
     * @param {boolean} cartHasProducts
     * @param {object} cartData
     */
    viewCartAnalytics (cartHasProducts, cartData) {
        if (cartHasProducts && cartData && cartData.items && cartData.items.length > 0) {
            const totalPrice = cartData.totalizers[0].valueNoFormat;
            const currencyCode = cartData.items[0].priceInformation.currency.code;
            const cartItemsAnalytis = this.itemsData(cartData);

            femcare.tracking.analytics.pushEcommerce('view_cart', {
                currency: currencyCode,
                value: totalPrice,
                items: cartItemsAnalytis
            });
        }
    },

    /**
     * Triggers on click on Finalize shopping, on chart and cart-notification modals
     * @param {object} cartData
     */
    beginCheckoutAnalytics (cartData) {
        if (!cartData || !cartData.items) {
            return;
        }
        const cartItemsAnalytis = this.itemsData(cartData);
        femcare.tracking.analytics.pushEcommerce('begin_checkout', { items: cartItemsAnalytis });
    },


    /**
     * Makes object with appropriate data for ga4 DataLayer
     * @param {object} cartData
     * @returns {object} cartItemsAnalytics
     */
    itemsData (cartData) {
        const cartItemsAnalytics = [];
        const cartItems = cartData.items;

        for (let cartIndex = 0; cartIndex < cartItems.length; cartIndex++) {
            const product = cartItems[cartIndex];

            const item = {
                item_id: product.productId,
                item_name: product.name,
                currency: product.priceInformation.currency.code,
                discount: product.priceInformation.discount,
                item_variant: product.productSkuName,
                price: product.priceInformation.priceWithoutDiscountNoFormat,
                quantity: product.productQuantity.initial
            }

            cartItemsAnalytics.push(item);
        }

        return cartItemsAnalytics;
    }
}
